import React, { useEffect, useState } from "react";
import { useThemeColor } from "../../../context/ThemeContext";
import {
  updateApplicationBackgroundMode,
  updateChatMessageStreaming,
} from "./services/settingService";
import showMessage from "../../common/message";

const Setting = () => {
  const { theme, toggleTheme, allowMessageStreaming, toggleMessageStreaming } = useThemeColor();

  const handleChangeTheme = async (e) => {
    const selectedTheme = e.target.value;
    toggleTheme(selectedTheme);
    const res = await updateApplicationBackgroundMode(selectedTheme);
    if (res !== null && res !== undefined) {
      showMessage(res.Status);
    }
  };

  const handleChangeMessageStreaming = async (e) => {
    const allowStreaming = e.target.checked;
    toggleMessageStreaming(allowStreaming);
    const res = await updateChatMessageStreaming(allowStreaming);
    if (res !== null && res !== undefined) {
      showMessage(res.Status);
    }
  };

  return (
    <>
      <div className="height-100">
        <div className="section-wrapper ">
          <h2 className="h2">Application Background Mode </h2>
          <label className="checkbox-container">
            {" "}
            Light
            <input
              type="radio"
              value="light"
              checked={theme === "light"}
              onChange={handleChangeTheme}
            />
            <span className="custom-check"></span>
          </label>
          <label className="checkbox-container">
            {" "}
            Dark
            <input
              type="radio"
              value="dark"
              checked={theme === "dark"}
              onChange={handleChangeTheme}
            />
            <span className="custom-check"></span>
          </label>
        </div>
        <div className="section-wrapper">
          <h2 className="h2">Chat Message Streaming </h2>
          <div className="check-ackn">
            <label className="check-contain font-display-streaming">
              <input
                type="checkbox"
                onChange={handleChangeMessageStreaming}
                checked={allowMessageStreaming}
                className="p-checkbox"
              />
              <span className="checkmark-check"></span>
              <p>Allow Message Streaming</p>
            </label>
          </div>
        </div>
      </div>
    </>
  );
};

export default Setting;
